import styled from "styled-components";
import { device } from "src/theme/mediaQueries";

export const StyledSidebar = styled.div`
  background-color: ${({ theme }) => theme.colors.blueLight3};
  border: ${({ theme }) => theme.colors.blueLight2};
  box-shadow: 0 0 18px rgb(0 0 0 / 20%);
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 266px;
  transition: width 300ms ease-in-out;

  @media ${device.tablet} {
    background-color: transparent;
    width: 100%;
  }

  &.collapsed {
    width: 100px;

    .logo-wrapper {
      display: flex;
      justify-content: center;
    }

    .sidebar-timer {
      justify-content: center;
      padding: 17px 0;
    }

    .sidebar-logout {
      display: flex;
      justify-content: center;
    }

    .btn-logout {
      padding: 14px 10px;
      width: auto;

      .btn-title {
        margin: 0;
        width: 0;
      }
    }
  }

  .btn-logout {
    align-items: center;
    appearance: none;
    background-color: transparent;
    border: none;
    display: inline-flex;
    color: ${({ theme }) => theme.colors.blueDark};
    font-size: ${({ theme }) => theme.fonts.fontSizeXXS};
    font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};
    font-weight: ${({ theme }) => theme.fonts.fontWeightRegular};
    cursor: pointer;
    padding: 14px 24px;
    white-space: nowrap;
    width: 100%;

    &:hover {
      filter: brightness(1.2);
    }

    .icon-wrapper {
      display: flex;
    }

    .btn-title {
      margin: 4px 0 0 10px;
      overflow: hidden;
      width: auto;
      transition: width 300ms;
    }
  }

  .sidebar-logout {
    margin: auto 0 0;
  }

  .sidebar-toggle {
    position: absolute;
    right: -20px;
    top: 19px;
    transition: transform 500ms;
    z-index: 9;

    &.rotate {
      transform: rotate(180deg);
    }
  }

  .logo-wrapper {
    padding: 26px 30px;
  }

  .logo-wrapper,
  .sidebar-nav,
  .sidebar-play {
    border-bottom: 1px solid ${({ theme }) => theme.colors.blueLight2};

    @media ${device.tablet} {
      border: none;
    }
  }

  .sidebar-timer {
    display: flex;
    padding: 26px 22px;

    @media ${device.tablet} {
      padding: 0;
      position: absolute;
      right: 4.5%;
      bottom: 3px;
    }

    @media (max-width: 575px) {
      bottom: 68px;
    }
  }

  .sidebar-nav {
    padding: 12px 0;

    @media ${device.tablet} {
      align-items: center;
      background-color: ${({ theme }) => theme.colors.blueLight3};
      display: flex;
      justify-content: center;
      padding: 0 0 0 75px;
      position: relative;
    }
  }

  &:before {
    @media ${device.tablet} {
      background-image: url("data:image/svg+xml,%3Csvg width='600' height='69' viewBox='0 0 600 69' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_b_13762_45742)'%3E%3Cpath d='M0 31.3024V15.4731C0 14.9209 0.34173 14.4731 0.894015 14.4731C14.3802 14.4731 176.84 14.4731 242.067 14.4731C267.403 14.4731 273.145 0 299.494 0C325.843 0 327.532 14.4731 359.286 14.4731C439.483 14.4732 592.441 14.4732 592.441 14.4732H599C599.552 14.4732 600 14.9209 600 15.4732V68C600 68.5523 599.552 69 599 69H0.999999C0.447714 69 0 68.5523 0 68V31.3024Z' fill='%23F2F9FF'/%3E%3Cpath d='M0.5 31.3024V15.4731C0.5 15.2972 0.554397 15.1677 0.620197 15.0907C0.679705 15.0209 0.76425 14.9731 0.894015 14.9731H0.974739H1.05886H1.14637H1.23726H1.33151H1.42912H1.53007H1.63435H1.74196H1.85287H1.96709H2.08459H2.20538H2.32942H2.45673H2.58728H2.72106H2.85807H2.99828H3.1417H3.28831H3.43809H3.59104H3.74715H3.90641H4.0688H4.23431H4.40294H4.57467H4.74949H4.92738H5.10835H5.29237H5.47944H5.66955H5.86268H6.05882H6.25797H6.46011H6.66523H6.87331H7.08436H7.29835H7.51528H7.73514H7.95791H8.18358H8.41215H8.64359H8.87791H9.11509H9.35512H9.59798H9.84367H10.0922H10.3435H10.5976H10.8545H11.1141H11.3765H11.6417H11.9096H12.1802H12.4536H12.7296H13.0084H13.2898H13.5739H13.8607H14.1501H14.4422H14.7368H15.0341H15.334H15.6366H15.9416H16.2493H16.5595H16.8723H17.1876H17.5054H17.8258H18.1487H18.474H18.8019H19.1322H19.465H19.8002H20.1379H20.478H20.8205H21.1655H21.5128H21.8625H22.2146H22.5691H22.9259H23.2851H23.6465H24.0104H24.3765H24.7449H25.1156H25.4886H25.8638H26.2413H26.621H27.003H27.3872H27.7736H28.1622H28.553H28.946H29.3411H29.7384H30.1378H30.5394H30.9431H31.3488H31.7567H32.1667H32.5788H32.9929H33.4091H33.8273H34.2476H34.6699H35.0942H35.5205H35.9488H36.3791H36.8113H37.2455H37.6816H38.1197H38.5597H39.0016H39.4454H39.8911H40.3387H40.7882H41.2395H41.6927H42.1477H42.6045H43.0631H43.5235H43.9858H44.4498H44.9156H45.3831H45.8524H46.3234H46.7961H47.2706H47.7468H48.2246H48.7042H49.1854H49.6683H50.1528H50.6389H51.1267H51.6161H52.1071H52.5997H53.0939H53.5897H54.087H54.5858H55.0862H55.5882H56.0916H56.5966H57.103H57.6109H58.1203H58.6312H59.1435H59.6573H60.1725H60.6891H61.2071H61.7265H62.2473H62.7694H63.2929H63.8178H64.344H64.8716H65.4005H65.9306H66.4621H66.9948H67.5289H68.0642H68.6007H69.1385H69.6775H70.2177H70.7592H71.3018H71.8457H72.3907H72.9368H73.4841H74.0326H74.5822H75.1329H75.6848H76.2377H76.7917H77.3468H77.9029H78.4601H79.0184H79.5777H80.138H80.6993H81.2616H81.8249H82.3892H82.9544H83.5206H84.0878H84.6559H85.2249H85.7948H86.3656H86.9373H87.5099H88.0833H88.6576H89.2328H89.8088H90.3856H90.9632H91.5416H92.1208H92.7008H93.2816H93.8631H94.4453H95.0283H95.6121H96.1965H96.7816H97.3675H97.954H98.5411H99.129H99.7175H100.307H100.896H101.487H102.078H102.669H103.261H103.854H104.447H105.041H105.635H106.23H106.826H107.422H108.018H108.615H109.212H109.81H110.408H111.007H111.606H112.206H112.806H113.406H114.007H114.608H115.209H115.811H116.413H117.015H117.618H118.221H118.825H119.428H120.032H120.637H121.241H121.846H122.451H123.056H123.661H124.267H124.872H125.478H126.084H126.691H127.297H127.903H128.51H129.117H129.723H130.33H130.937H131.544H132.151H132.759H133.366H133.973H134.58H135.187H135.794H136.402H137.009H137.616H138.223H138.83H139.437H140.043H140.65H141.257H141.863H142.469H143.075H143.681H144.287H144.893H145.498H146.104H146.709H147.314H147.918H148.523H149.127H149.73H150.334H150.937H151.54H152.143H152.745H153.347H153.949H154.55H155.151H155.752H156.352H156.952H157.551H158.15H158.748H159.346H159.944H160.541H161.138H161.734H162.33H162.925H163.52H164.114H164.707H165.3H165.893H166.485H167.076H167.667H168.257H168.846H169.435H170.024H170.611H171.198H171.784H172.37H172.955H173.539H174.122H174.705H175.287H175.868H176.449H177.028H177.607H178.185H178.763H179.339H179.915H180.49H181.063H181.637H182.209H182.78H183.351H183.92H184.489H185.057H185.623H186.189H186.754H187.318H187.881H188.443H189.004H189.563H190.122H190.68H191.237H191.793H192.347H192.901H193.453H194.005H194.555H195.104H195.652H196.199H196.745H197.289H197.833H198.375H198.916H199.456H199.994H200.531H201.067H201.602H202.136H202.668H203.199H203.729H204.257H204.784H205.31H205.834H206.357H206.879H207.399H207.918H208.435H208.951H209.466H209.979H210.491H211.001H211.51H212.017H212.523H213.027H213.53H214.031H214.531H215.029H215.526H216.021H216.515H217.007H217.497H217.986H218.473H218.959H219.442H219.925H220.405H220.884H221.361H221.837H222.31H222.783H223.253H223.721H224.188H224.653H225.117H225.578H226.038H226.496H226.952H227.406H227.859H228.309H228.758H229.205H229.65H230.093H230.534H230.973H231.41H231.846H232.279H232.711H233.14H233.568H233.993H234.417H234.838H235.257H235.675H236.09H236.504H236.915H237.324H237.731H238.136H238.539H238.939H239.338H239.734H240.129H240.521H240.911H241.298H241.684H242.067C254.72 14.9731 262.543 11.3876 270.368 7.80171L270.609 7.69112C278.49 4.07983 286.432 0.5 299.494 0.5C311.942 0.5 318.814 3.74891 326.082 7.18468C326.437 7.35244 326.793 7.52064 327.15 7.68893C334.873 11.3248 343.309 14.9731 359.286 14.9731L505.938 14.9732L567.289 14.9732L585.712 14.9732L590.704 14.9732L592 14.9732H592.33H592.413H592.434H592.44C592.441 14.9732 592.441 14.9732 592.441 14.4732V14.9732H599C599.276 14.9732 599.5 15.197 599.5 15.4732V68C599.5 68.2761 599.276 68.5 599 68.5H0.999999C0.723857 68.5 0.5 68.2761 0.5 68V31.3024Z' stroke='%23AED5F1'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_b_13762_45742' x='-8' y='-8' width='616' height='85' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeGaussianBlur in='BackgroundImageFix' stdDeviation='4'/%3E%3CfeComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_13762_45742'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_backgroundBlur_13762_45742' result='shape'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E%0A");
      background-repeat: no-repeat;
      background-size: cover;
      display: inline-flex;
      content: "";
      position: absolute;
      left: 0;
      width: 100%;
      width: 100%;
      height: 45px;
      top: -14px;
    }

    @media (max-width: 420px) {
      left: 50%;
      transform: translate(-50%, 0);
      width: 600px;
    }
  }
`;
